import React, { useState } from 'react';
import { ButtonPrimary, spacer16 } from '@spotify-internal/encore-web';

// import { useTranslation } from 'providers/translations/TranslationProvider';
import { IsHelpfulAnswerEnum } from 'experiments/feedback-position/hooks/useIsHelpfulAnswer';
import { ReasonKey } from 'experiments/feedback-position/hooks/useSubmitReason';
import HelpfulPoll from 'experiments/feedback-position/components/HelpfulPoll';
import ThanksMessage from 'experiments/feedback-position/components/ThanksMessage';
import ReasonSelector from 'experiments/feedback-position/components/ReasonSelector';

interface FeedbackWidgetContentProps {
  isHelpfulAnswered?: IsHelpfulAnswerEnum;
  answerIfIsHelpful: (answer: IsHelpfulAnswerEnum) => void;
  isSubmittedReason: boolean;
  submitReason: (reason: ReasonKey) => void;
  trackMessageUsLink: () => void;
}
const FeedbackWidgetContent = ({
  isHelpfulAnswered,
  answerIfIsHelpful,
  isSubmittedReason,
  submitReason,
  trackMessageUsLink,
}: FeedbackWidgetContentProps) => {
  // const { t } = useTranslation();
  const [reason, setReason] = useState<ReasonKey>();

  if (isSubmittedReason || isHelpfulAnswered === IsHelpfulAnswerEnum.yes) {
    return <ThanksMessage answered={isHelpfulAnswered} trackMessageUsLink={trackMessageUsLink} />;
  }

  if (isHelpfulAnswered === IsHelpfulAnswerEnum.no) {
    return (
      <form
        onSubmit={e => {
          e.preventDefault();
          if (reason) submitReason(reason);
        }}
      >
        <ReasonSelector selected={reason} onSelect={setReason} />
        <ButtonPrimary type="submit" buttonSize="sm" disabled={!reason} css={{ marginTop: spacer16 }}>
          {/* {t('feedback_submit_reason')}*/}
          Submit
        </ButtonPrimary>
      </form>
    );
  }

  return (
    <HelpfulPoll
      onYesClick={() => answerIfIsHelpful(IsHelpfulAnswerEnum.yes)}
      onNoClick={() => answerIfIsHelpful(IsHelpfulAnswerEnum.no)}
    />
  );
};

export default FeedbackWidgetContent;
